// extracted by mini-css-extract-plugin
export var cardLayout = "_7o-1";
export var paginationContainer = "_7o-0";